import { FETCH_CURRENT_USER } from '../actions';


const initialState = {
    isLoggedIn: false,
    headers: [],
    footers: []
}
// return visible header routes

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_CURRENT_USER: 
            return action.payload.data;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/client/reducers/authReducer.js